const _BASE = "/services/api";

const _URL = {
  // 上传头像
  UPLOAD_HEAD_URL: `${_BASE}/iam/user/uploadAvatar`,
};
export default _URL;